import { useQuery } from "react-query"
import { fetchCompanyCookies } from "./api"

// eslint-disable-next-line import/prefer-default-export
export const useCompanyCookies = () => {
  return useQuery("fetchCompanyCookies", fetchCompanyCookies)
}
